import React from 'react';
import Card from '../../../components/ACS-Dashboard/ACS-Blocks/Card';
import ScrollableContainer from '../../../components/ACS-Dashboard/ACS-Blocks/ScrollableContainer';

const AppointmentsList = ({ isCollapsed }) => {
  const cardsData = [
    { title: "Upcoming Appointments", percentage: "+18%", percentageColor: "text-green-500", comparisonText: "vs last week", mainValue: "22", buttonText: "View" },
    { title: "Completed Appointments", percentage: "+9%", percentageColor: "text-green-500", comparisonText: "vs yesterday", mainValue: "15", buttonText: "Details" },
    { title: "Cancelled Appointments", percentage: "-6%", percentageColor: "text-red-500", comparisonText: "vs last month", mainValue: "4", buttonText: "Review" },
    { title: "No-show Cases", percentage: "+2%", percentageColor: "text-red-500", comparisonText: "vs last week", mainValue: "3", buttonText: "Check" },
    { title: "Rescheduled", percentage: "+5%", percentageColor: "text-green-500", comparisonText: "vs last month", mainValue: "6", buttonText: "Track" },
    { title: "Flagged Appointments", percentage: "+1%", percentageColor: "text-yellow-500", comparisonText: "vs last month", mainValue: "2", buttonText: "Resolve" }
  ];

  return (
    <div className="p-fluid-1 bg-color-custom-bg-purple">
      <ScrollableContainer direction="x" className="scrollbar-none">
        <div className="flex gap-[clamp(0.5rem,1cqw,1rem)]"> {/* Container-queried gap */}
          {cardsData.map((card, index) => (
            <div 
              key={index} 
              className="scroll-snap-align-start"
              style={{ 
                minWidth: 'clamp(12rem,30cqw,11rem)',  // 30% of container width
                flex: '0 0 auto'  // Prevent flex growing
              }}
            >
              <Card 
                {...card}
                className="p-fluid-1.5"
                titleClassName="text-fluid-lg"
                valueClassName="text-fluid-xl"
                metaClassName="text-fluid-sm"
              />
            </div>
          ))}
        </div>
      </ScrollableContainer>
    </div>
  );
};

export default AppointmentsList;

